import { render, staticRenderFns } from "./double_top.vue?vue&type=template&id=45978617"
import script from "./double_top.vue?vue&type=script&lang=js"
export * from "./double_top.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports